// opervex-frontend/src/routes/PrivateRouteWrapper.js

import { useParams } from "react-router-dom";
import PrivateRoute from "./privateRoute";

const PrivateRouteWrapper = ({ children, requiredRoles, admin }) => {
  const { tenantId } = useParams();

  return (
    <PrivateRoute tenantId={tenantId} requiredRoles={requiredRoles} admin={admin}>
      {children}
    </PrivateRoute>
  );
};

export default PrivateRouteWrapper;
